import { isPlatformServer } from '@angular/common';
import {
  Component,
  Inject,
  Optional,
  inject,
  PLATFORM_ID,
} from '@angular/core';
import { Response } from 'express';
import { RESPONSE } from '../../server.token';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
})
export class PageNotFoundComponent {
  constructor(
    @Optional() @Inject(RESPONSE) private response: Response,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformServer(this.platformId) && this.response) {
      this.response.status(404);
    }
  }
}
